/**
 * LandingPageWithSharedLogin - 공유 로그인 기능이 포함된 랜딩 페이지
 * FSD Architecture: apps 레이어의 페이지 구성 요소
 */
import React from 'react';
import { useLocation } from 'react-router';
import { LandingPage } from '@edusense/pages-landing';
import { handleSharedGeminiLogin } from '../../../utils/shared-login';
import {
  landing_heroTitle,
  landing_heroTitleSuffix,
  landing_heroDescription, 
  landing_featuresTitle,
  landing_features_aiCoding_title,
  landing_features_aiCoding_description,
  landing_features_aiTutor_title,
  landing_features_aiTutor_description,
  landing_features_socialLearning_title,
  landing_features_socialLearning_description,
  landing_features_ugcContent_title,
  landing_features_ugcContent_description,
  landing_features_ideIntegration_title,
  landing_features_ideIntegration_description,
  landing_footer_copyright,
  landing_startLearning,
  common_login,
  common_loading
} from '@paraglide/messages';

/**
 * 🚀 Paraglide JS 네이티브 솔루션: Zero-runtime i18n
 */
export const LandingPageWithSharedLogin: React.FC = () => {
  const location = useLocation();
  
  // 현재 언어 추출 (URL params에서)
  const urlParams = location.pathname.split('/');
  const currentLang = urlParams[1] && /^[a-z]{2}$/.test(urlParams[1]) ? urlParams[1] : 'ko';
  
  console.log('🟢 LandingPageWithSharedLogin - 현재 언어:', currentLang);
  
  // 🎯 Paraglide 네이티브: 컴파일 타임에 번역 완료, 런타임 로딩 불필요
  
  // MainPage와 동일한 공통 함수 사용
  const handleCommonLogin = () => {
    console.log('🚀 공통 handleSharedGeminiLogin 함수 호출:', currentLang);
    return handleSharedGeminiLogin(currentLang);
  };
  
  // Paraglide 네이티브 함수로 번역된 content 생성
  const landingContent = {
    hero: {
      title: landing_heroTitle(),
      gradientText: "EduSense",
      titleSuffix: landing_heroTitleSuffix(),
      description: landing_heroDescription()
    },
    features: {
      title: landing_featuresTitle(),
      items: [
        {
          icon: "🤖",
          title: landing_features_aiCoding_title(),
          description: landing_features_aiCoding_description()
        },
        {
          icon: "🎓",
          title: landing_features_aiTutor_title(),
          description: landing_features_aiTutor_description()
        },
        {
          icon: "💬",
          title: landing_features_socialLearning_title(),
          description: landing_features_socialLearning_description()
        },
        {
          icon: "🎨",
          title: landing_features_ugcContent_title(),
          description: landing_features_ugcContent_description()
        },
        {
          icon: "💻",
          title: landing_features_ideIntegration_title(),
          description: landing_features_ideIntegration_description()
        }
      ]
    },
    footer: {
      copyright: landing_footer_copyright()
    }
  };
  
  return (
    <LandingPage 
      content={landingContent}
      ctaText={landing_startLearning()}
      loginText={common_login()}
      loadingText={common_loading()}
      onLoginClick={handleCommonLogin}
      onStartClick={handleCommonLogin}
    />
  );
};

export default LandingPageWithSharedLogin;